import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useKid } from "@/context/KidContext";
import { toast } from "sonner";
import { Link } from "react-router-dom";

export default function Family() {
  const { active, reloadKids } = useKid();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/contents", { params: { category: "dinamicas" } }).then(({ data }) => setItems(data.contents));
  }, []);

  const complete = async (contentId) => {
    if (!active) return toast.error("Selecione uma criança no perfil.");
    await api.post("/progress", { child_id: active.id, content_id: contentId, kind: "familia" });
    await reloadKids();
    toast.success("+15 pontos! Momento em família registrado 💛");
  };

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-10 py-8">
      <h1 className="text-3xl font-extrabold text-[#243B53]">Momento em Família</h1>
      <p className="text-[#243B53]/70">Atividades para pais e filhos fazerem juntos.</p>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
        {items.map((c) => (
          <div key={c.id} data-testid={`family-card-${c.id}`} className="card-soft p-6">
            <div className="flex items-start gap-4">
              <div className="text-5xl">👨‍👩‍👧</div>
              <div className="flex-1">
                <div className="chip chip-leaf capitalize">{c.theme || "família"}</div>
                <h3 className="mt-1 font-extrabold text-[#243B53] text-lg">{c.title}</h3>
                <p className="text-sm text-[#243B53]/75 mt-1">{c.description}</p>
                <div className="mt-2 text-xs text-[#243B53]/60">{c.duration_min} min • {c.age_groups?.join(", ")}</div>
                <div className="mt-4 flex gap-2">
                  <Link to={`/content/${c.id}`} className="btn-outline text-sm">Abrir</Link>
                  <button onClick={() => complete(c.id)} data-testid={`family-complete-${c.id}`} className="btn-primary text-sm">Marcar como feito</button>
                </div>
              </div>
            </div>
          </div>
        ))}
        {items.length === 0 && (
          <div className="card-soft p-10 text-center text-[#243B53]/60 md:col-span-2">
            Em breve mais dinâmicas em família.
          </div>
        )}
      </div>
    </div>
  );
}
